export default __webpack_public_path__ + "static/media/14_WildEnough.8e9bafcf.mp3";